/**
 * Section: Rose Orange - 25 tiges — copie dérivée de section-fleurs-botte.js (personnalisable indépendamment).
 */

(function () {
  'use strict';

  function classTokenEndsWith(el, suffix) {
    if (!el || !el.classList) return false;
    for (var i = 0; i < el.classList.length; i++) {
      if (el.classList[i].endsWith(suffix)) return true;
    }
    return false;
  }

  function firstByClassSuffix(root, suffix) {
    var nodes = root.querySelectorAll('[class]');
    for (var i = 0; i < nodes.length; i++) {
      if (classTokenEndsWith(nodes[i], suffix)) return nodes[i];
    }
    return null;
  }

  function allByClassSuffix(root, suffix) {
    var out = [];
    var nodes = root.querySelectorAll('[class]');
    for (var i = 0; i < nodes.length; i++) {
      if (classTokenEndsWith(nodes[i], suffix)) out.push(nodes[i]);
    }
    return out;
  }

  function classPrefixForSuffix(el, suffix) {
    if (!el || !el.classList) return '';
    for (var i = 0; i < el.classList.length; i++) {
      var cls = el.classList[i];
      if (cls.endsWith(suffix)) return cls.slice(0, cls.length - suffix.length);
    }
    return '';
  }

  function parseMoney(value) {
    if (value === null || value === undefined) return 0;
    var str = String(value);
    // Exemple: "+80€", "352 € TTC", "67,00€"
    var match = str.replace(/\s/g, '').match(/[-+]?\d+(?:[.,]\d+)?/);
    if (!match) return 0;
    var normalized = match[0].replace(',', '.');
    var num = parseFloat(normalized);
    return isNaN(num) ? 0 : num;
  }

  function formatAmount(num) {
    if (typeof num !== 'number' || isNaN(num)) return '0';
    var isInt = Math.round(num) === num;
    if (isInt) return String(num);
    // Format FR simple : 2 décimales, virgule
    return num.toFixed(2).replace('.', ',');
  }

  function joinFormattedAmountAndSuffix(formatted, rawSuffix) {
    var t = String(rawSuffix || '').trim();
    if (!t) return formatted;
    return formatted + ' ' + t;
  }

  function postJsonJsConfig() {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
    };
  }

  function collectLineProperties(container) {
    var props = {};
    var postal = container.querySelector('[data-delivery-postal]');
    if (!postal) postal = container.querySelector('input[name="properties[Code postal ou ville]"]');
    if (postal && postal.value) {
      var pVal = postal.value.trim();
      if (pVal) props['Code postal ou ville'] = pVal;
    }

    var hid = container.querySelector('[data-delivery-date]');
    if (!hid) hid = container.querySelector('input[name="properties[Date de livraison]"]');
    if (hid && hid.value) {
      var dRaw = hid.value.trim();
      if (dRaw) props['Date de livraison'] = dRaw;
    }

    var selectedSize = container.querySelector('[data-kit-option="size"].is-selected');
    var size = selectedSize ? firstByClassSuffix(selectedSize, '__size-option-label') : null;
    if (size && size.textContent.trim()) props['Taille'] = size.textContent.trim();

    var selectedFlower = container.querySelector('[data-kit-option="flower"].is-selected');
    var flower = selectedFlower ? firstByClassSuffix(selectedFlower, '__option-title') : null;
    if (flower && flower.textContent.trim()) props['Pack fleurs'] = flower.textContent.trim();

    var selectedMaterial = container.querySelector('[data-kit-option="material"].is-selected');
    var material = selectedMaterial ? firstByClassSuffix(selectedMaterial, '__option-title') : null;
    if (material && material.textContent.trim()) props['Pack materiel'] = material.textContent.trim();

    var color = container.querySelector('[data-color-name].is-selected');
    if (color) {
      var colorName = color.getAttribute('data-color-name');
      if (colorName && colorName.trim()) props['Couleur'] = colorName.trim();
    }

    return props;
  }

  function resolveVariantId(container) {
    var selected = container.querySelector('[data-kit-option="size"].is-selected');
    var vid = selected ? (selected.getAttribute('data-variant-id') || '').trim() : '';

    // Fallback 1: premier bloc taille porteur d'un variant, même si non sélectionné
    if (!vid) {
      var firstSizeWithVariant = container.querySelector('[data-kit-option="size"][data-variant-id]');
      if (firstSizeWithVariant) vid = (firstSizeWithVariant.getAttribute('data-variant-id') || '').trim();
    }

    // Fallback 2: valeur data-* injectée côté section (variant par défaut)
    if (!vid && container.dataset && container.dataset.fleursDefaultVariant) {
      vid = String(container.dataset.fleursDefaultVariant).trim();
    }

    // Fallback 3: input hidden standard Shopify (name="id")
    if (!vid) {
      var idInput = container.querySelector('input[name="id"][value]');
      if (idInput) vid = String(idInput.value || '').trim();
    }

    // Fallback 4: paramètre URL ?variant=...
    if (!vid) {
      try {
        var fromUrl = new URLSearchParams(window.location.search).get('variant');
        if (fromUrl) vid = String(fromUrl).trim();
      } catch (_e1) {}
    }

    vid = vid.replace(/\s/g, '');
    if (!/^\d+$/.test(vid)) return '';
    return vid;
  }

  function wireAddToCart(container, addToCartBtn) {
    if (!addToCartBtn || addToCartBtn.dataset.fleursCartBound === '1') return;
    addToCartBtn.dataset.fleursCartBound = '1';

    addToCartBtn.addEventListener('click', function () {
      if (addToCartBtn.classList.contains('loading') || addToCartBtn.getAttribute('aria-disabled') === 'true') return;

      var vid = resolveVariantId(container);
      if (!vid) {
        window.alert('Variante introuvable. Dans l editeur de theme, renseignez "Produit pour le panier" (ou "ID variante Shopify" si vous utilisez des tailles).');
        return;
      }

      var qtyInput = container.querySelector('[data-qty-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(qty) || qty < 1) qty = 1;
      var variantNum = Number(vid);
      var props = collectLineProperties(container);
      var cartBubble = document.querySelector('cart-dropdown-bubble');
      var routesObj = typeof window.routes !== 'undefined' && window.routes ? window.routes : {};
      var cartUrl = routesObj.cart_add_url || '/cart/add.js';

      var item = { id: variantNum, quantity: qty };
      if (Object.keys(props).length > 0) item.properties = props;

      var formQuantity = {};
      formQuantity[item.id] = qty;

      addToCartBtn.classList.add('loading');
      addToCartBtn.setAttribute('aria-disabled', 'true');

      var cfg = postJsonJsConfig();
      cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
      var bodyObj = { items: [item] };

      if (cartBubble && typeof cartBubble.getSectionsToRender === 'function') {
        try {
          bodyObj.sections = cartBubble.getSectionsToRender().map(function (s) { return s.id; });
          bodyObj.sections_url = window.location.pathname;
        } catch (_outer) {}
      }
      cfg.body = JSON.stringify(bodyObj);

      fetch(cartUrl, cfg)
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            var msg = response.description || response.message || 'Impossible d ajouter au panier.';
            if (cartBubble && typeof cartBubble.renderError === 'function') cartBubble.renderError(msg);
            else window.alert(msg);
            return;
          }
          response.quantityItem = formQuantity;
          if (cartBubble && typeof cartBubble.renderContents === 'function') cartBubble.renderContents(response);
        })
        .catch(function (err) {
          console.error(err);
          window.alert('Une erreur est survenue lors de l ajout au panier.');
        })
        .finally(function () {
          addToCartBtn.classList.remove('loading');
          addToCartBtn.removeAttribute('aria-disabled');
          try {
            if (typeof window.cartAjax !== 'undefined' && window.cartAjax && typeof openCartModal === 'function') openCartModal();
            else if (routesObj.cart_url) window.location.href = routesObj.cart_url;
            else window.location.href = '/cart';
          } catch (_e2) {}
        });
    });
  }


  function setupMobileStickyCart(container, buttonWrap, originalButton) {
    if (!container || !buttonWrap || !originalButton || buttonWrap.dataset.stickyCartBound === '1') return null;
    buttonWrap.dataset.stickyCartBound = '1';

    var stickyWrap = buttonWrap.cloneNode(true);
    stickyWrap.classList.add('oeillet-blanc-20-tiges__sticky-button-wrap');
    stickyWrap.classList.remove('is-visible');
    stickyWrap.setAttribute('aria-hidden', 'true');
    stickyWrap.removeAttribute('data-sticky-cart-bound');

    var stickyWishlist = stickyWrap.querySelector('.oeillet-blanc-20-tiges__wishlist-button');
    if (stickyWishlist) stickyWishlist.remove();

    var stickyButton = stickyWrap.querySelector('[data-fleurs-add-to-cart]') || stickyWrap.querySelector('[data-perle-add-to-cart]') || stickyWrap.querySelector('.oeillet-blanc-20-tiges__button');
    if (stickyButton) {
      stickyButton.removeAttribute('data-fleurs-add-to-cart');
      stickyButton.removeAttribute('data-perle-add-to-cart');
      stickyButton.removeAttribute('data-fleurs-cart-bound');
      stickyButton.addEventListener('click', function () {
        originalButton.click();
      });
    }

    var originalQtyInput = container.querySelector('[data-qty-input]');
    if (stickyButton && originalQtyInput) {
      var stickyQty = document.createElement('div');
      stickyQty.className = 'oeillet-blanc-20-tiges__sticky-qty';

      var stickyMinus = document.createElement('button');
      stickyMinus.type = 'button';
      stickyMinus.className = 'oeillet-blanc-20-tiges__sticky-qty-btn';
      stickyMinus.setAttribute('aria-label', 'Diminuer la quantite');
      stickyMinus.textContent = '-';

      var stickyQtyValue = document.createElement('span');
      stickyQtyValue.className = 'oeillet-blanc-20-tiges__sticky-qty-value';
      stickyQtyValue.setAttribute('aria-live', 'polite');

      var stickyPlus = document.createElement('button');
      stickyPlus.type = 'button';
      stickyPlus.className = 'oeillet-blanc-20-tiges__sticky-qty-btn';
      stickyPlus.setAttribute('aria-label', 'Augmenter la quantite');
      stickyPlus.textContent = '+';

      function clampStickyQty(value) {
        var min = parseInt(originalQtyInput.getAttribute('min'), 10) || 1;
        var max = parseInt(originalQtyInput.getAttribute('max'), 10) || 99;
        var qty = parseInt(value, 10);
        if (isNaN(qty)) qty = min;
        if (qty < min) qty = min;
        if (qty > max) qty = max;
        return qty;
      }

      function syncStickyQty() {
        stickyQtyValue.textContent = String(clampStickyQty(originalQtyInput.value));
      }

      function setOriginalQty(value) {
        originalQtyInput.value = String(clampStickyQty(value));
        originalQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        syncStickyQty();
      }

      stickyMinus.addEventListener('click', function () {
        setOriginalQty((parseInt(originalQtyInput.value, 10) || 1) - 1);
      });
      stickyPlus.addEventListener('click', function () {
        setOriginalQty((parseInt(originalQtyInput.value, 10) || 1) + 1);
      });
      originalQtyInput.addEventListener('change', syncStickyQty);
      originalQtyInput.addEventListener('input', syncStickyQty);
      originalQtyInput.addEventListener('blur', syncStickyQty);

      stickyQty.appendChild(stickyMinus);
      stickyQty.appendChild(stickyQtyValue);
      stickyQty.appendChild(stickyPlus);
      stickyWrap.insertBefore(stickyQty, stickyButton);
      syncStickyQty();
    }

    document.body.appendChild(stickyWrap);

    var mobileQuery = window.matchMedia('(max-width: 767px)');

    function setStickyVisible(visible) {
      var shouldShow = visible && mobileQuery.matches;
      stickyWrap.classList.toggle('is-visible', shouldShow);
      stickyWrap.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function originalButtonVisible() {
      var rect = buttonWrap.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.bottom > 0 && rect.top < viewportHeight;
    }

    function updateStickyState() {
      setStickyVisible(!originalButtonVisible());
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setStickyVisible(!(entry && entry.isIntersecting));
      }, { threshold: 0.01 });
      observer.observe(buttonWrap);
    } else {
      window.addEventListener('scroll', updateStickyState, { passive: true });
    }

    window.addEventListener('resize', updateStickyState);
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', updateStickyState);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(updateStickyState);
    }

    updateStickyState();
    return stickyButton;
  }

  function initBotteColorQuantity(root) {
    var colorsRoot = root.querySelector('[data-botte-colors]');
    if (colorsRoot) {
      var nameEl = colorsRoot.querySelector('[data-botte-color-name]');
      var swatches = colorsRoot.querySelectorAll('[data-color-name]');
      function selectSwatch(btn) {
        if (!btn) return;
        swatches.forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        if (nameEl) {
          nameEl.textContent = btn.getAttribute('data-color-name') || '';
        }
      }
      swatches.forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectSwatch(btn);
        });
      });
      if (swatches.length) {
        selectSwatch(swatches[0]);
      }
    }

    var qtyRoot = root.querySelector('[data-botte-qty]');
    if (qtyRoot) {
      var input = qtyRoot.querySelector('[data-qty-input]');
      var minus = qtyRoot.querySelector('[data-qty-minus]');
      var plus = qtyRoot.querySelector('[data-qty-plus]');
      if (input && minus && plus) {
        var qMin = parseInt(input.getAttribute('min'), 10) || 1;
        var qMax = parseInt(input.getAttribute('max'), 10) || 99;

        function clampQty() {
          var v = parseInt(input.value, 10);
          if (isNaN(v)) v = qMin;
          if (v < qMin) v = qMin;
          if (v > qMax) v = qMax;
          input.value = String(v);
        }

        minus.addEventListener('click', function () {
          input.value = String((parseInt(input.value, 10) || qMin) - 1);
          clampQty();
        });
        plus.addEventListener('click', function () {
          input.value = String((parseInt(input.value, 10) || qMin) + 1);
          clampQty();
        });
        input.addEventListener('change', clampQty);
        input.addEventListener('blur', clampQty);
        clampQty();
      }
    }
  }

  function initFleursBotte(container) {
    if (!container) return;

    // Galerie : clic sur une miniature pour mettre à jour l'image principale
    var mainImageWrapper = firstByClassSuffix(container, '__main-image');
    var mainImg = mainImageWrapper ? mainImageWrapper.querySelector('img') : null;
    var thumbs = allByClassSuffix(container, '__thumb');

    // Carrousel miniatures (flèches + scroll horizontal)
    var thumbCarousel = firstByClassSuffix(container, '__thumb-carousel');
    var thumbViewport = firstByClassSuffix(container, '__thumbnails');
    var prevBtn = firstByClassSuffix(container, '__thumb-prev');
    var nextBtn = firstByClassSuffix(container, '__thumb-next');

    function updateCarouselButtons() {
      if (!thumbViewport || !prevBtn || !nextBtn) return;
      var maxScrollLeft = thumbViewport.scrollWidth - thumbViewport.clientWidth;
      var atStart = thumbViewport.scrollLeft <= 0;
      var atEnd = thumbViewport.scrollLeft >= maxScrollLeft - 1;
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    }

    if (thumbCarousel && thumbViewport && prevBtn && nextBtn) {
      // Rendre la "fenêtre" des miniatures égale à la largeur de l'image principale
      var syncThumbViewportWidth = function () {
        if (!mainImageWrapper) return;
        var w = mainImageWrapper.getBoundingClientRect().width;
        if (w && w > 0) {
          thumbViewport.style.maxWidth = Math.round(w) + 'px';
          thumbViewport.style.width = Math.round(w) + 'px';
        } else {
          thumbViewport.style.maxWidth = '';
          thumbViewport.style.width = '';
        }
        updateCarouselButtons();
      };

      var step = function () {
        // Avance d'environ 70% de la largeur visible
        return Math.round(thumbViewport.clientWidth * 0.7);
      };

      prevBtn.addEventListener('click', function () {
        thumbViewport.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        thumbViewport.scrollBy({ left: step(), behavior: 'smooth' });
      });

      thumbViewport.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateCarouselButtons);
      });
      window.addEventListener('resize', function () {
        syncThumbViewportWidth();
      });

      // Etat initial
      syncThumbViewportWidth();
    }

    // Sélection par défaut (première miniature) si aucune n'est active
    if (thumbs && thumbs.length > 0) {
      var anyActive = false;
      thumbs.forEach(function (t) {
        if (t.classList.contains('is-active')) anyActive = true;
      });
      if (!anyActive) {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumbs[0].classList.add('is-active');
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = thumb.querySelector('img');
        if (img && mainImg) {
          // Utiliser directement l'URL HD prévue côté Liquid (évite les regex qui ne matchent pas toujours)
          var largeSrc = img.dataset.largeSrc;
          if (largeSrc) {
            mainImg.setAttribute('src', largeSrc);
            mainImg.setAttribute('data-lightbox-src', largeSrc);
          } else {
            var src = img.getAttribute('src');
            if (src) {
              mainImg.setAttribute('src', src);
              mainImg.setAttribute('data-lightbox-src', src);
            }
          }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        }
      });
    });

    // Accordéons : un seul ouvert à la fois
    var toggles = container.querySelectorAll('[data-accordion-toggle]');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var accordion = toggle.parentElement;
        if (!accordion) return;
        var group = accordion.parentElement;
        var willOpen = !accordion.classList.contains('is-open');
        if (group) {
          group.querySelectorAll('[data-accordion-toggle]').forEach(function (otherToggle) {
            var other = otherToggle.parentElement;
            if (!other || other === accordion) return;
            other.classList.remove('is-open');
            otherToggle.setAttribute('aria-expanded', 'false');
          });
        }
        accordion.classList.toggle('is-open', willOpen);
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    // Fleurs / matériel : « Voir tous » → affiche le reste des options (grille normale)
    container.querySelectorAll('[data-kit-view-all]').forEach(function (btn) {
      if (btn.dataset.kitExpandBound === '1') return;
      var kind = btn.getAttribute('data-kit-view-all');
      if (!kind) return;
      var wrap = btn.closest('[class*="__option-cards"]');
      if (!wrap) return;
      var primary = firstByClassSuffix(wrap, '__option-cards-primary');
      var extra = wrap.querySelector('[data-kit-extra="' + kind + '"]');
      if (!extra) return;
      var extraInner = firstByClassSuffix(extra, '__option-cards-extra-inner');
      if (!primary || !extraInner) return;
      btn.dataset.kitExpandBound = '1';
      if (!btn.dataset.kitViewAllLabel) {
        btn.dataset.kitViewAllLabel = btn.textContent.trim();
      }
      var openLabel = btn.dataset.kitViewAllLabel;
      var closeLabel = btn.getAttribute('data-kit-view-less') || 'Voir moins';

      btn.addEventListener('click', function () {
        var show = extra.hidden;
        if (show) {
          extra.hidden = false;
          // Ouvert: le bouton devient le dernier item du bloc des options visibles.
          extraInner.appendChild(btn);
          btn.setAttribute('aria-expanded', 'true');
          btn.textContent = closeLabel;
        } else {
          // Fermé: le bouton revient sur la ligne principale (3 options + bouton).
          primary.appendChild(btn);
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = openLabel;
          extra.hidden = true;
        }
      });
    });

    // Bloc SEO repliable (Voir plus / Voir moins)
    var seoBlocks = container.querySelectorAll('[data-seo-collapsible]');
    seoBlocks.forEach(function (seoBlock) {
      var content = seoBlock.querySelector('[data-seo-content]');
      var btn = seoBlock.querySelector('[data-seo-toggle]');
      if (!content || !btn) return;

      // Afficher le bouton uniquement si le contenu déborde la hauteur clampée
      var shouldCollapse = content.scrollHeight > content.clientHeight + 4;
      if (!shouldCollapse) {
        btn.hidden = true;
        return;
      }

      btn.hidden = false;
      btn.addEventListener('click', function () {
        var expanded = seoBlock.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });

    // Date & livraison : panneau + calendrier custom (style Rose Beige)
    var deliveryPanel = firstByClassSuffix(container, '__delivery-panel');
    var deliveryDateInput = container.querySelector('[data-delivery-date]');
    if (!deliveryDateInput) {
      deliveryDateInput = container.querySelector('input[name="properties[Date de livraison]"]');
    }
    if (deliveryPanel && deliveryDateInput) {
      var detailsEl = firstByClassSuffix(deliveryPanel, '__delivery-panel-card');
      if (detailsEl) {
        var syncDeliveryPanelState = function () {
          deliveryPanel.classList.toggle('is-collapsed', !detailsEl.open);
        };
        detailsEl.addEventListener('toggle', syncDeliveryPanelState);
        syncDeliveryPanelState();
      }

      var leadDays = parseInt(deliveryPanel.getAttribute('data-lead-days') || '30', 10);
      if (isNaN(leadDays) || leadDays < 0) leadDays = 30;

      function stripTime(d) {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
      }

      var today = stripTime(new Date());
      var minDate = stripTime(new Date(today));
      minDate.setDate(minDate.getDate() + 7);

      var gridEl = deliveryPanel.querySelector('[data-fleurs-calendar-grid]');
      var monthLabel = deliveryPanel.querySelector('[data-fleurs-calendar-month]');
      var prevCalBtn = deliveryPanel.querySelector('[data-fleurs-calendar-prev]');
      var nextCalBtn = deliveryPanel.querySelector('[data-fleurs-calendar-next]');

      if (gridEl && monthLabel && prevCalBtn && nextCalBtn) {
        var calRoot = firstByClassSuffix(deliveryPanel, '__delivery-calendar');
        var deliveryPrefix = classPrefixForSuffix(calRoot || deliveryPanel, '__delivery-calendar');
        var dayClass = (deliveryPrefix ? deliveryPrefix + '__delivery-cal-day' : 'fleurs-botte__delivery-cal-day');
        var monthNamesFr = ['Janvier','Fevrier','Mars','Avril','Mai','Juin','Juillet','Aout','Septembre','Octobre','Novembre','Decembre'];
        var view = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
        var selected = stripTime(new Date(minDate));

        function sameDay(a, b) {
          return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
        }
        function toIso(d) {
          var y = d.getFullYear();
          var m = String(d.getMonth() + 1).padStart(2, '0');
          var da = String(d.getDate()).padStart(2, '0');
          return y + '-' + m + '-' + da;
        }
        function lastDateOfMonth(y, m0) { return new Date(y, m0 + 1, 0).getDate(); }
        function mondayIndex(d) { return (d.getDay() + 6) % 7; }
        function firstOfMonth(y, m0) { return new Date(y, m0, 1); }
        function canPrev() {
          var v = firstOfMonth(view.getFullYear(), view.getMonth());
          var minM = firstOfMonth(minDate.getFullYear(), minDate.getMonth());
          return v > minM;
        }
        function updateNavState() {
          var ok = canPrev();
          prevCalBtn.disabled = !ok;
          prevCalBtn.classList.toggle('is-disabled', !ok);
        }
        function renderCalendar() {
          monthLabel.textContent = monthNamesFr[view.getMonth()] + ' ' + view.getFullYear();
          gridEl.innerHTML = '';
          var y = view.getFullYear();
          var m = view.getMonth();
          var first = new Date(y, m, 1);
          var startPad = mondayIndex(first);
          var daysInMonth = lastDateOfMonth(y, m);
          for (var i = 0; i < 42; i++) {
            var dayOffset = i - startPad + 1;
            var cellDate;
            var isMuted = false;
            if (dayOffset < 1) { cellDate = new Date(y, m, dayOffset); isMuted = true; }
            else if (dayOffset > daysInMonth) { cellDate = new Date(y, m, dayOffset); isMuted = true; }
            else { cellDate = new Date(y, m, dayOffset); }
            var dOnly = stripTime(cellDate);
            var cell = document.createElement('button');
            cell.type = 'button';
            cell.className = dayClass + ' fleurs-botte__delivery-cal-day';
            if (isMuted) cell.classList.add('is-muted');
            if (dOnly < minDate) {
              cell.classList.add('is-disabled');
              cell.disabled = true;
            }
            if (!isMuted && sameDay(dOnly, selected)) cell.classList.add('is-selected');
            cell.textContent = String(cellDate.getDate());
            var iso = toIso(dOnly);
            cell.setAttribute('data-iso', iso);
            if (!cell.disabled) {
              cell.addEventListener('click', function () {
                var picked = this.getAttribute('data-iso');
                if (!picked) return;
                var parts = picked.split('-');
                selected = stripTime(new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10)));
                deliveryDateInput.value = picked;
                renderCalendar();
                deliveryDateInput.dispatchEvent(new Event('change', { bubbles: true }));
              });
            }
            gridEl.appendChild(cell);
          }
          updateNavState();
        }
        prevCalBtn.addEventListener('click', function () {
          if (!canPrev()) return;
          view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
          renderCalendar();
        });
        nextCalBtn.addEventListener('click', function () {
          view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
          renderCalendar();
        });
        deliveryDateInput.value = toIso(selected);
        renderCalendar();
      }
    }

    initBotteColorQuantity(container);

    // Sélections (taille / fleurs / matériel) + recalcul du prix
    var priceEl = container.querySelector('[data-price-value]');
    var addToCartBtn = container.querySelector('[data-fleurs-add-to-cart]');
    if (!addToCartBtn) addToCartBtn = firstByClassSuffix(container, '__button');
    if (!priceEl || !addToCartBtn) return;

    wireAddToCart(container, addToCartBtn);
    var stickyAddToCartBtn = setupMobileStickyCart(container, addToCartBtn.closest('.oeillet-blanc-20-tiges__button-wrap'), addToCartBtn);

    var priceSuffix = priceEl.dataset.priceSuffix || '';
    var basePriceValue = parseMoney(priceEl.dataset.priceValue);

    // Libellé "bouton" après le tiret, sinon on prend le texte complet
    var rawBtnText = addToCartBtn.textContent.trim();
    var labelPart = rawBtnText;
    if (rawBtnText.indexOf('-') !== -1) {
      labelPart = rawBtnText.split('-').slice(1).join('-').trim();
    }

    var state = {
      sizeTotal: basePriceValue,
      flowerInc: 0,
      materialInc: 0,
    };

    function updatePriceAndButton() {
      var total = state.sizeTotal + state.flowerInc + state.materialInc;
      var formatted = formatAmount(total);
      var display = joinFormattedAmountAndSuffix(formatted, priceSuffix);
      priceEl.textContent = display;
      addToCartBtn.textContent = display + ' - ' + labelPart;
      if (stickyAddToCartBtn) stickyAddToCartBtn.textContent = addToCartBtn.textContent;
    }

    // Taille (1 sélection)
    var sizeButtons = container.querySelectorAll('[data-kit-option="size"][data-size-total]');
    if (sizeButtons.length > 0) {
      sizeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeButtons.forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          state.sizeTotal = parseMoney(btn.dataset.sizeTotal);
          updatePriceAndButton();
        });
      });

      // Par défaut : première taille sélectionnée ; le total part du « Prix (affiché) » si renseigné, sinon du prix du bloc taille
      sizeButtons.forEach(function (b, idx) {
        if (idx === 0) {
          b.classList.add('is-selected');
          b.setAttribute('aria-pressed', 'true');
          var blockTotal = parseMoney(b.dataset.sizeTotal);
          state.sizeTotal = basePriceValue > 0 ? basePriceValue : blockTotal;
        }
      });
      updatePriceAndButton();
    } else {
      updatePriceAndButton();
    }

    // Fleurs (1 sélection)
    var flowerButtons = container.querySelectorAll('[data-kit-option="flower"][data-option-increment]');
    if (flowerButtons.length > 0) {
      flowerButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          flowerButtons.forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          state.flowerInc = parseMoney(btn.dataset.optionIncrement);
          updatePriceAndButton();
        });
      });
    }

    // Matériel (1 sélection)
    var materialButtons = container.querySelectorAll('[data-kit-option="material"][data-option-increment]');
    if (materialButtons.length > 0) {
      materialButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          materialButtons.forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          state.materialInc = parseMoney(btn.dataset.optionIncrement);
          updatePriceAndButton();
        });
      });
    }
  }

  function run() {
    var sections = document.querySelectorAll('.page-template__layout');
    sections.forEach(function (section) {
      if (section.querySelector('[data-price-value]')) {
        initFleursBotte(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Ré-initialiser après un changement dans le theme editor (Shopify section refresh)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.page-template__layout');
    if (section && section.querySelector('[data-price-value]')) initFleursBotte(section);
  });
})();
